module.exports = __webpack_public_path__ + "static/media/united-kingdom.91a93069.svg";